export const NotifStatus = {
	created: 1,
	sending: 2,
	sent: 3,
	failed: 4,
	skip: 5,
};